var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{staticClass:"upload-hide",attrs:{"action":"url","on-preview":_vm.preview,"on-remove":_vm.remove,"file-list":_vm.fileList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }